import { get, postForm } from 'app/common/helpers/fetch';
import { getC } from 'app/common/helpers/cookie';

const sessionStorageKey = 'verifiedUser';

function saveSession(user) {
  if (user && user.id) {
    try {
      sessionStorage.setItem(
        `${sessionStorageKey}-${user.id}`,
        JSON.stringify(user)
      );
    } catch (e) {}
  }
  return user;
}

export function removeSession() {
  try {
    const keys = Object.keys(sessionStorage).filter(key =>
      key.startsWith(sessionStorageKey)
    );
    keys.forEach(key => sessionStorage.removeItem(key));
  } catch (e) {}
}

/**
 * Get authed user from session storage
 */
export const getUserFromStorage = () => {
  let user = null;
  const c = getC();
  if (!c) {
    return user;
  }

  try {
    const userData = sessionStorage.getItem(`${sessionStorageKey}-${c}`);
    user = JSON.parse(userData);
    if (!user.id) {
      user = null;
    }
  } catch (e) {}

  return user;
};

export function loadUser() {
  // check snickerdoodle cookie first
  if (!getC()) {
    return Promise.resolve(null);
  }

  // load data from session storage second
  const user = getUserFromStorage();
  if (user) {
    return Promise.resolve(user);
  }

  return get('/layout/api/v2/current-user').then(saveSession);
}

export function signInForm(postData) {
  const { email, password, rememberMe } = postData;

  return postForm('/login/iframe', {
    email,
    password,
    remember_me: rememberMe ? 1 : 0,
  });
}

export function signInGoogle(googleUser) {
  const url = `${location.origin}/google_auth_callback${location.search}`;
  const postData = {
    id_token: googleUser.getAuthResponse().id_token,
    remember_me: 1,
  };

  return postForm(url, postData).then(resData => {
    const { redirectTo } = resData;
    return redirectTo || window.location.href;
  });
}

function fbLogin(option) {
  return new Promise(resolve => {
    window.FB.login(res => {
      if (res && res.status === 'connected') {
        if (res.authResponse) {
          const {
            grantedScopes = '',
            accessToken,
            signedRequest,
          } = res.authResponse;
          if (grantedScopes.includes('email')) {
            window.FB.api(
              '/me',
              {
                fields:
                  'id,name,email,first_name,last_name,picture.type(square)',
              },
              userInfo => {
                const postData = {
                  access_token: accessToken,
                  signed_request: signedRequest,
                  email: userInfo.email,
                  remember_me: true,
                };

                resolve({
                  type: 'save',
                  postData,
                });
              }
            );
          } else {
            resolve({
              type: 'reauth',
            });
          }
        } else {
          resolve({
            type: 'error',
            error: 'facebook_auth_response_error',
          });
        }
      } else {
        resolve({
          type: 'error',
          error: 'facebook_connected_error',
        });
      }
    }, option);
  });
}

export function signInFacebook(reauth = false) {
  const option = {
    scope: 'email,user_friends,user_hometown',
    return_scopes: true,
  };

  if (reauth) {
    option.auth_type = 'rerequest';
  }

  return fbLogin(option).then(result => {
    if (result.type !== 'save') {
      return result;
    }

    return postForm('/facebook', result.postData).then(resData => {
      const { location } = resData || {};
      return {
        type: 'success',
        location: location || window.location.href,
      };
    });
  });
}
